import React, { Component } from 'react'
import classnames from 'classnames'
import { Loading } from '@myxplor/ui'
import { fetchWithRetry } from '../../../authorisation'
import { apiEndpointGovEnrolments } from './index'
import { RecordListActions } from '../../../ui/gov-actions'
import { createCCSEnrolment } from './actions/create-enrolment'
import Enrolments from './view'
import Empty from './view/empty'
import Merge from '../merge'

const refreshAssociateRecords = ({ child_id, gov_id, jwt }) => dispatch =>
  fetchWithRetry(
    process.env.REACT_APP_API_HOST + `/api/children/${child_id}/ccs-enrolments/${gov_id}`,
    {
      token: jwt,
      method: 'POST',
      jsonAPI: true,
    },
    dispatch
  )

export default class CCSGovEnrolments extends Component {
  constructor() {
    super()
    this.state = {
      mergeStatus: {
        status: null,
        name: null,
      },
    }

    this.handleDrop = this.handleDrop.bind(this)
    this.fetchAssociateRecords = this.fetchAssociateRecords.bind(this)
  }

  fetchAssociateRecords(gov_id) {
    const { refresh_ccs_gov_enrolments, child, dispatchAction, jwt } = this.props
    const child_id = child.id

    return refreshAssociateRecords({
      child_id,
      gov_id,
      jwt,
    })(dispatchAction).then(
      response =>
        response.status === 200
          ? refresh_ccs_gov_enrolments(apiEndpointGovEnrolments({ child }))
          : Promise.reject('Unable to merge')
    )
  }

  handleDrop(monitor) {
    const droppedComponent = monitor.getItem()
    const gov_id = droppedComponent.id

    droppedComponent.mergePending()
    this.setState({
      mergeStatus: {
        name: droppedComponent.name,
        status: 'pending',
      },
    })

    this.fetchAssociateRecords(gov_id)
      .then(() => {
        this.setState({
          mergeStatus: {
            name: null,
            status: null,
          },
        })
        droppedComponent.mergeCompleted()
      })
      .catch(() => {
        this.setState({
          mergeStatus: {
            name: droppedComponent.name,
            status: 'failed',
          },
        })
        droppedComponent.mergeFailed()
      })

    return {
      gov_id,
    }
  }

  formatData(data) {
    return Array.isArray(data) ? data : [data]
  }

  render() {
    const { mergeStatus } = this.state
    const { canDrop, isOver, connectDropTarget, ccs_gov_enrolments } = this.props
    const { loading } = ccs_gov_enrolments

    if (loading) return <Loading>Loading matching CCS Government Enrolments</Loading>

    const data = this.formatData(ccs_gov_enrolments.data)

    return connectDropTarget(
      <div
        className={classnames({
          'recordDisplayList--wrapper': true,
          drop__canDrop: canDrop,
          drop__isOver: isOver,
        })}>
        {data.length > 0 ? (
          <Enrolments records={data} mergeStatus={mergeStatus} {...this.props} />
        ) : (
          <Empty>
            <RecordListActions options={[createCCSEnrolment(this.props)]} />
            <Merge {...mergeStatus} />
          </Empty>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/ccs-gov-enrolments.js